/**
 * Чему ляжет обивка из панели «Отделка»: выделенный предмет мягкой мебели — диван,
 * кресло, кровать с мягким изголовьем (`isUpholstered`). Другой предмет — обивки нет.
 */
import {
	fabricTextureById,
	getCatalogItem,
	isUpholstered,
	type CatalogItem,
	type FabricTextureKind,
	type FinishTexture,
} from "@/shared/catalog";
import { findFloorItem, type FloorItem } from "@/shared/plan";
import { useProjectStore } from "@/shared/store";
import { SelectionKind, useEditorStore } from "@/widgets/editor";

export interface FabricTarget {
	item: FloorItem;
	info: CatalogItem;
	/** Обивка предмета; нет — модель в своей */
	fabric: FinishTexture<FabricTextureKind> | null;
}

export const useFabricTarget = (): FabricTarget | null => {
	const selection = useEditorStore((s) => s.selection);
	const layers = useProjectStore((s) => s.project.layers);
	if (selection?.kind !== SelectionKind.Item) return null;
	const found = findFloorItem(layers, selection.id);
	const info = found ? getCatalogItem(found.item.ref) : null;
	if (!found || !info || !isUpholstered(info)) return null;
	const fabric = found.item.fabric ? fabricTextureById(found.item.fabric) : null;
	return { item: found.item, info, fabric };
};
